var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.mdContent)?_c('type-wrapper',{staticClass:"type-R",attrs:{"regular":"","bgImage":_vm.showData.image,"bgColor":_vm.showData.bg_color}},[_c('div',{staticClass:"md-body",domProps:{"innerHTML":_vm._s(_vm.renderedContent)}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }